"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSettingsToGql = exports.mapSettingsToVod = exports.mapPricingToGql = exports.mapPricingToVod = void 0;
var tslib_1 = require("tslib");
var deal_info_types_1 = require("@wix/wix-vod-constants/dist/common/deal-info-types");
var globalTypes_1 = require("../generated/globalTypes");
var pricing_1 = require("../mappers/pricing");
exports.mapPricingToVod = pricing_1.createMapPricingToVod(new Map([
    [globalTypes_1.SettingsDefaultPricingType.SALE, deal_info_types_1.DEAL_INFO_TYPES.SALE],
    [globalTypes_1.SettingsDefaultPricingType.RENT, deal_info_types_1.DEAL_INFO_TYPES.RENT],
]));
exports.mapPricingToGql = pricing_1.createMapPricingToGql(new Map([
    [deal_info_types_1.DEAL_INFO_TYPES.SALE, globalTypes_1.SettingsDefaultPricingType.SALE],
    [deal_info_types_1.DEAL_INFO_TYPES.RENT, globalTypes_1.SettingsDefaultPricingType.RENT],
]));
exports.mapSettingsToVod = function (settings) {
    var defaultChannelId = settings.defaultChannelId, defaultPricing = settings.defaultPricing, currency = settings.currency, embedLogos = settings.embedLogos, extendOptions = settings.extendOptions;
    return tslib_1.__assign({ defaultChannelId: defaultChannelId,
        currency: currency, dealInfo: defaultPricing.map(exports.mapPricingToVod), embedLogos: embedLogos.default.map(function (url) { return ({
            url: url,
            id: url,
        }); }), embedDefaultLogoId: embedLogos.selected }, extendOptions);
};
exports.mapSettingsToGql = function (settings) {
    var variables = {
        currency: settings.currency,
        defaultChannelId: settings.defaultChannelId,
        defaultPricing: settings.dealInfo.map(exports.mapPricingToGql),
        embedLogos: settings.embedLogos.map(function (_a) {
            var url = _a.url;
            return url;
        }),
        selectedEmbedLogo: settings.embedDefaultLogoId,
        extendOptions: {},
    };
    Object.keys(settings).forEach(function (key) {
        if (key in variables) {
            return;
        }
        if (key === 'dealInfo') {
            return;
        }
        variables.extendOptions[key] = settings[key];
    });
    return variables;
};
//# sourceMappingURL=settings.mappers.js.map